import { PAGE_MAX } from '@oberoninternal/travelbase-website/dist/components/designsystem/Pagination';
import Companies, { BaseProps } from '@oberoninternal/travelbase-website/dist/components/pages/Companies';
import { GetStaticProps } from 'next';
import { getGlobalProps } from '../../utils/addGlobalQuery';
import styled from 'styled-components';
import ContentWrapper from '@oberoninternal/travelbase-website/dist/components/ContentWrapper';

const Index = (props: BaseProps) => (
    <CompaniesWrapper>
        <Companies {...props} contentWrapperVariant="searchList" amountPerPage={PAGE_MAX} buttonTypes={['filters']} />
    </CompaniesWrapper>
);

const CompaniesWrapper = styled.div`
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.l}) {
        ${ContentWrapper as never} {
            padding-left: calc(var(--logoOffsetLeft) + var(--wrapperPadding));
        }
    }
`;

export default Index;

export const getStaticProps: GetStaticProps = getGlobalProps;
